import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import MyTable from '../../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


//Redux
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'
import allActions from "../../../../../actions";

// Utils
import { isEmpty } from 'lodash';
import { getConsultingId, getShortMonthName } from "../../../../utils/utils";
import { ClickAwayListener, Grow, IconButton, Menu, MenuItem, MenuList, Paper, Popper, Tooltip, Typography } from "@material-ui/core";
import { unoTheme } from "../../../../../assets/styles/unoTheme";

import { resolveMonthStatusDair } from "../statusDairUtils";

import ChangeStatusDairModal from "../../../../modals/ChangeStatusDairModal";
import SearchBar from "../../../../utils/SearchBar";
import { StatusDpinDairAPI } from "../../../../../API/status_dpin_dair";
import { path } from "../../../../utils/routesPaths";
import { ClientAPI } from "../../../../../API/client";

import SortIcon from '@material-ui/icons/Sort';
import CommentIcon from '@material-ui/icons/Comment';
import { classificationsMap } from '../../../backOffice/NewClientScreen';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    dpinColumn: {
        background: '#fdffe0 !important',
        borderBottom: 'solid 0.2px #efefef !important',
        '&.MuiTableCell-body': {
            '&:hover': {
                background: '#fbffc7 !important',
            }
        }

    },

    commentIcon: {
        cursor: "pointer",
        color: unoTheme.mainGrayColor,

        '&:hover': {
            color: unoTheme.mainColor,
        }
    },

    hoverMonth: {
        cursor: "pointer",
        '&:hover': {
            color: unoTheme.mainColor + " !important",
        }
    }

}));

export default function DairTab(props) {

    const {
        selectedYearClosure,
        statusClientsArray,
        setStatusClientsArray,
        statusesDair,
        activeStatusesDair,
        page,
        totalItems,
        handlePage,
        limit,
        search,
        setSearch,
        sortOrder,
        setSortOrder,
        selectedAdvisor,
        selectedDairFilter,
        filterDairMonthSelected,
        mySnapshotDate,
        onSnapshot,
    } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)

    const [sortMenuAnchor, setSortMenuAnchor] = useState(null);

    //MENU troca de status
    const [openChangeStatusMenuDair, setOpenChangeStatusMenuDair] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedClientInfo, setSelectedClientInfo] = useState(null);

    //Status escolhido no menu, aguardando o comentário obrigatório
    const [pendingStatus, setPendingStatus] = useState(null);

    const handleToggleDair = () => {
        setOpenChangeStatusMenuDair((prevOpen) => !prevOpen);
    };

    const closeChangeStatusMenu = () => {
        setOpenChangeStatusMenuDair(false);
    };

    const handleCloseDair = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        closeChangeStatusMenu();
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenChangeStatusMenuDair(false);
        }
    }

    function openChangeStatusDair(target,
        month,
        year,
        selectedClient) {
        setSelectedClientInfo({
            client: selectedClient,
            month: month,
            year: year,
            currentStatus: resolveMonthStatusDair(selectedClient, month, statusesDair)
        })
        handleToggleDair();
        setAnchorEl(target);
    }

    //Status que exigem comentário passam pelo modal; os demais trocam direto
    function handleSelectStatusDair(statusSelected) {

        closeChangeStatusMenu();

        if (statusSelected.comment_required === false) {
            doChangeStatusDair(selectedClientInfo, statusSelected, null);
            return;
        }

        setPendingStatus(statusSelected);
    }

    function handleCommentDialogAction(comment) {

        const statusSelected = pendingStatus;
        const infoClient = selectedClientInfo;

        setPendingStatus(null);

        if (!comment || !statusSelected || !infoClient) return;

        doChangeStatusDair(infoClient, statusSelected, comment);
    }

    async function doChangeStatusDair(infoClient, statusSelected, comment) {

        const response = await StatusDpinDairAPI.changeStatusDair(statusSelected.id,
            infoClient.client.id,
            currentUser.user.id,
            infoClient.month,
            infoClient.year,
            comment);

        if (response.success) {
            updateViewStatusDairClient(infoClient.client.id, infoClient.month, statusSelected)
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao alterar o status DAIR",
                type: 'error',
            }));
        }

    }

    function renderMenuChangeStatusDair(items) {

        const menuList = [];

        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-dairs-' + item.id}
                onClick={() => handleSelectStatusDair(item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    function renderColumnsStatus(clientRow) {

        const columnsClient = [];

        for (let monthLoop = 1; monthLoop <= 12; monthLoop++) {

            const statusMonth = resolveMonthStatusDair(clientRow, monthLoop, statusesDair);

            const labelNameMonth = statusMonth ? statusMonth.name : "";
            const labelShortNameMonth = statusMonth ? statusMonth.short_name : '-';
            const colorStatusMonth = statusMonth ? statusMonth.color : "";

            const unClickAble = !statusMonth;

            columnsClient.push(
                <TableCell
                    key={'status-dair-' + clientRow.id + '-' + monthLoop}
                    onClick={(e) => (
                        (unClickAble || onSnapshot) ? null : openChangeStatusDair(e.currentTarget,
                            monthLoop,
                            selectedYearClosure,
                            clientRow
                        ))}
                    align="center" style={unClickAble ? { pointerEvents: 'none', paddingLeft: '4px', paddingRight: '4px' } : { paddingLeft: '2px', paddingRight: '2px' }}>
                    <Tooltip button
                        title={labelNameMonth}
                        enterDelay={200}
                        leaveDelay={100}
                        placement="bottom"
                        arrow>
                        <div style={{
                            fontWeight: '600',
                            fontSize: '10px',
                            letterSpacing: '1px',
                            color: colorStatusMonth,
                        }}>{labelShortNameMonth}</div>
                    </Tooltip>
                </TableCell>
            );
        }

        return columnsClient;
    }

    function updateViewStatusDairClient(clientId, month, newStatus) {
        const newValuesStatusClientsArray = [...statusClientsArray];

        const clientToChange = newValuesStatusClientsArray.find(el => el.id == clientId);

        if (clientToChange) {

            if (!clientToChange[month]) clientToChange[month] = {}
            clientToChange[month].dair_name = newStatus.name;
            clientToChange[month].dair_short_name = newStatus.short_name;
            clientToChange[month].dair_color = newStatus.color;

            setStatusClientsArray(newValuesStatusClientsArray);
        }
    }

    async function detailClient(clientId) {

        const clientSelected = await ClientAPI.getClientById(clientId);

        console.log('clientSelected: ', clientSelected);

        if (clientSelected.success) {
            history.push(
                {
                    pathname: path.administration.client.details.newClient,
                    state: { client: clientSelected.body }
                }
            )
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao carregar cliente",
                type: 'error',
            }));

        }

    }

    function handleOpenTotalizer(isDPIN, month) {

        dispatch(allActions.rightContentActions.setRightContent({
            path: "statusesClientsByMonth",
            data: {
                isDPIN: isDPIN,
                year: selectedYearClosure,
                advisorId: selectedAdvisor && selectedAdvisor.id,
                consultingId: getConsultingId(currentUser),
                search: search,
                dairStatusIdFilter: selectedDairFilter && selectedDairFilter.id,
                monthFilterDair: month ? month : selectedDairFilter ? (parseInt(filterDairMonthSelected) + 1) : null,
                dpinStatusIdFilter: null,
                snapshotDate: mySnapshotDate,
            }
        }))
    }

    return (
        <div className={classes.root}>

            <div class={'defaultScrollWithHeaderContent'}>

                <MyTable
                    pagination={
                        isEmpty(search) &&
                        statusClientsArray
                        && statusClientsArray.length > 0
                        && selectedAdvisor == null
                        && selectedDairFilter == null
                    }
                    itemspage={limit}
                    totalitems={totalItems}
                    currentPage={page}
                    handlePage={handlePage}
                    stickyHeader
                    withBorderColumn
                    size="small">
                    <colgroup>
                        <col width="20%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                align="left"
                                style={{ paddingLeft: '0px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SearchBar
                                        name='search_query'
                                        mask='text_cnpj'
                                        size='small'
                                        spacingRight
                                        variant='outlined'
                                        label='Cliente'
                                        setSearchQuery={setSearch}
                                    />
                                    <Tooltip title="Ordenação" placement="top" arrow>
                                        <IconButton size="small" onClick={(e) => setSortMenuAnchor(e.currentTarget)}>
                                            <SortIcon style={{ color: sortOrder !== 'alpha_asc' ? '#1976d2' : undefined }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 1)}>Jan</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 2)}>Fev</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center" onClick={() => handleOpenTotalizer(false, 3)}>Mar</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 4)}>Abr</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 5)}>Mai</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 6)}>Jun</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 7)}>Jul</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 8)}>Ago</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 9)}>Set</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 10)}>Out</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 11)}>Nov</TableCell>
                            <TableCell
                                className={classes.hoverMonth}
                                align="center"
                                onClick={() => handleOpenTotalizer(false, 12)}>Dez</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {statusesDair && statusClientsArray
                            && statusClientsArray.map((row) => (
                                <TableRow
                                    key={'portfolio-launch-client-' + row.id}>
                                    <TableCell
                                        onClick={() => detailClient(row.id)}
                                        align="left">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div>{row.label_name}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {row.classification && (
                                                    <div style={{
                                                        borderRadius: '4px',
                                                        background: classificationsMap[row.classification]?.color,
                                                        padding: '1px 6px',
                                                        fontSize: '10px',
                                                        color: '#fff',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        {row.classification}
                                                    </div>
                                                )}
                                                <CommentIcon className={classes.commentIcon}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        dispatch(allActions.rightContentActions.setRightContent({
                                                            path: 'statusesClientHistoric',
                                                            data: {
                                                                year: selectedYearClosure,
                                                                clientId: row.id,
                                                            }
                                                        }))
                                                    }} />
                                            </div>
                                        </div>
                                    </TableCell>
                                    {renderColumnsStatus(row)}
                                </TableRow>
                            ))}
                    </TableBody>
                </MyTable>
            </div>

            <Popper
                open={openChangeStatusMenuDair}
                anchorEl={anchorEl}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleCloseDair}>
                                {openChangeStatusMenuDair ?
                                    <div>
                                        <Typography style={{ fontSize: '12px', padding: '8px', borderBottom: 'solid 1px #eeeeee' }}>{selectedClientInfo && (selectedClientInfo.client.label_name + ' (' + getShortMonthName(selectedClientInfo.month)
                                            + '/' + selectedClientInfo.year) + ")"}</Typography>

                                        <MenuList style={{ maxHeight: '150px', overflowY: 'scroll' }} autoFocusItem={openChangeStatusMenuDair} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                            {renderMenuChangeStatusDair(activeStatusesDair || [])}
                                        </MenuList>

                                    </div> : <div></div>
                                }
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            <ChangeStatusDairModal
                open={Boolean(pendingStatus)}
                clientInfo={selectedClientInfo}
                currentStatus={selectedClientInfo && selectedClientInfo.currentStatus}
                statusSelected={pendingStatus}
                handleAction={handleCommentDialogAction} />

            <Menu
                id="sort-order-menu"
                anchorEl={sortMenuAnchor}
                keepMounted
                open={Boolean(sortMenuAnchor)}
                onClose={() => setSortMenuAnchor(null)}>
                {[
                    { value: 'priority_desc', label: 'Ordenar por prioridade Desc' },
                    { value: 'priority_asc', label: 'Ordenar por prioridade Asc' },
                    { value: 'alpha_asc', label: 'Ordenar Alfabética Asc' },
                    { value: 'alpha_desc', label: 'Ordenar Alfabética Desc' },
                ].map(opt => (
                    <MenuItem
                        key={opt.value}
                        selected={sortOrder === opt.value}
                        onClick={() => { setSortOrder(opt.value); setSortMenuAnchor(null); }}>
                        <Typography style={{ fontSize: '13px' }}>{opt.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>

        </div>
    );
}
